<template>
  <iframe v-if="embedUrl" :src="embedUrl" width="100%" height="100%"></iframe>

  <div v-else-if="errorMsg != null">
      <div class="alert alert-danger show mt-2" role="alert">{{ errorMsg }}</div>
    </div>
</template>

<script>

export default {
  props: ['auth', 'currentSite'],
  data() {
    return {
      embedUrl: null,
      errorMsg: null
    }
  },
  watch: {
    auth(val) {
      if (val) {
        this.init()
      }
    },
    currentSite() {
      this.init()
    }
  },
  async mounted() {
    if (!this.auth) {
      return
    }

    await this.init()
  },
  methods: {
    async init() {
      if (this.currentSite) {
        await this.getEmbedUrl()
      }
    },
    async getEmbedUrl() {
      const response = await this.getAiAssistantEmbedUrl()
      if (response.code === 0) {
        this.embedUrl = response.data?.url
      } else {
        this.errorMsg = response.data?.message ?? 'AI 助手暫時未能使用'
      }
    }
  }
}
</script>

<style scoped>

</style>
